
/* eslint-disable class-methods-use-this */
import Component from 'vue-class-component';
import Vue from 'vue';
import { Prop, Watch } from 'vue-property-decorator';
import { ModalState } from '@/core/types/modal-state';
import { ProfileAPIService } from '@/profile/services/api';
import { Alert } from '@/core/types/alert';
import { AlertTypeEnum } from '@/core/types/alert-type-enum';
import { CoreHelper } from '@/core/helper';
import { ProfileLinkedAccount } from '@/profile/types/profile-linked-account';
import { namespace } from 'vuex-class';

const profileNamespace = namespace('profile');

const DELETE_SUCCESS_MESSAGE = 'Account Successfully Deleted';

@Component
export default class ProfileMyProfileDeleteLinkedAccountModal extends Vue {
	@Prop({ required: true })
	public account!: ProfileLinkedAccount;

	public alert: Alert | null = null;

	@profileNamespace.Action('getAndSetLinkedAccounts')
	public getAndSetLinkedAccounts!: () => Promise<void>;

	public isLoading = false;

	public isShown = false;

	@Prop({ default: { isShown: false } })
	public state!: ModalState;

	public wasDeleteSuccessful = false;

	@Watch('state')
	public watchState(state: { isShown: boolean }): void {
		this.isShown = state.isShown;
	}

	public async deleteAccount(): Promise<void> {
		this.isLoading = true;

		try {
			await ProfileAPIService.deleteLinkedAccount(this.account.id);
			await this.getAndSetLinkedAccounts();

			this.wasDeleteSuccessful = true;

			this.alert = {
				type: AlertTypeEnum.SUCCESS,
				message: DELETE_SUCCESS_MESSAGE,
			};
		} catch (error) {
			console.error(error);

			this.alert = {
				type: AlertTypeEnum.ERROR,
				message: CoreHelper.getHttpErrorMessage(error),
			};
		}

		this.isLoading = true;
	}

	public close(): void {
		this.isShown = false;
		this.reset();
	}

	private reset(): void {
		this.alert = null;
		this.isLoading = false;
		this.wasDeleteSuccessful = false;
	}
}
